import React, { useState } from "react";
import "./DShieldPro_Faq.css";

const AccordionItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="accordion-item">
      <div className="accordion-header" id={question}>
        <button
          className={`accordion-button ${isOpen ? "" : "collapsed"}`}
          type="button"
          onClick={onClick}
          aria-expanded={isOpen}
          aria-controls={question}
        >
          <span className="title">{question}</span>
        </button>
      </div>
      <div
        id={question}
        className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
        aria-labelledby={question}
      >
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

const Accordion = ({}) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const items = [
    {
      question: "How does the Dshield Pro app lock my phone?",
      answer:
        "The app automatically locks your phone if EMI payments are missed, ensuring compliance with financial commitments.",
    },
    {
      question: "Can I unlock my phone after making the payment?",
      answer:
        "Yes, your device unlocks instantly once the app verifies successful EMI payment.",
    },
    {
      question: "Is the Dshield Pro app secure and tamper-proof?",
      answer:
        "Absolutely! The app has anti-tamper security features to prevent unauthorized uninstallation or bypass.",
    },
    {
      question: "Does the app work on all mobile devices?",
      answer:
        "Currently, Dshield Pro supports Android devices and integrates smoothly with payment systems.",
    },
    {
      question: "Will the app affect my phone’s performance or battery life?",
      answer:
        "No, the app runs efficiently in the background without impacting performance or battery usage.",
    },
  ];

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="section harsafe-choose-us-section-02 section-padding">
      <div className="container">
        {/* <!-- Pricing Wrap Start --> */}
        <div className="pricing-wrap">
          <div className="section-title text-center">
            <h3 className="sub-title">FAQ</h3>
            <h2 className="title">FAQ's</h2>
          </div>
          <div className="pricing-content-wrap">
            <div className="col-lg-8 col-md-12 m-auto">

              <div className="choose-us-right">
                <div className="faq-accordion">
                  <div className="accordion" id="accordionExample">
                    {items.map((item, index) => (
                      <AccordionItem
                        key={index}
                        question={item.question}
                        answer={item.answer}
                        isOpen={activeIndex === index}
                        onClick={() => handleClick(index)}
                      />
                    ))}
                  </div>
                </div>
              </div>
              

            </div>
          </div>
        </div>
        {/* <!-- Pricing Wrap End --> */}
      </div>
    </div>
  );
};

export default Accordion;
